import styled from 'styled-components'

const ButtonStyled = styled.button`
  all: unset;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 0;
  padding: 0 16px;
  outline: 0;
  overflow: visible;
  font-family: inherit;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5715;
  background-color: #ff1945;
  border: 1px solid #ff1945;
  border-radius: 28px;
  color: #ffffff;
  touch-action: manipulation;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: #232323;
    background-color: #dadada;
    border-color: transparent;
  }

  @media (min-width: 768px) {
    width: unset;
    font-size: 14px;
  }
`

export default ButtonStyled
